import * as tslib_1 from "tslib";
import React, { useMemo } from 'react';
import ReactTooltip from 'react-tooltip';
export const Tooltip = (_a) => {
    var { id, content, children } = _a, rest = tslib_1.__rest(_a, ["id", "content", "children"]);
    const tooltipId = useMemo(() => id, [id]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { "data-tip": true, "data-for": tooltipId }, children),
        React.createElement(ReactTooltip, Object.assign({}, rest, { id: tooltipId }), content)));
};
//# sourceMappingURL=Tooltip.js.map